import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { enCA } from './en-CA';
import { frCA } from './fr-CA';

// tslint:disable: class-name
export class i18nLoader extends TranslateLoader {
    private i18n = {
        'fr-CA' : frCA,
        'en-CA' : enCA
    };

    public getTranslation(lang: string): Observable<any> {
        return Observable.of(this.i18n[lang]);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/i18n/i18nLoader.ts